"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDuoContract = function IconDuoContract(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M7 43h34v-2H9V5H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M27.91 20.937c.761.011 1.042-.214 1.216-.438.25-.321.39-.777.615-1.506l.014-.045c.204-.663.486-1.563 1.134-2.267.703-.764 1.712-1.181 3.111-1.181 1.088 0 1.901.251 2.563.685.555.363.964.838 1.278 1.203l.107.123c.35.403.641.702 1.053.925.403.217 1.002.4 1.999.4v2c-1.253 0-2.194-.233-2.95-.64-.746-.404-1.234-.939-1.61-1.37l-.097-.113c-.343-.395-.569-.654-.876-.855-.292-.192-.713-.358-1.467-.358-.97 0-1.395.27-1.64.536-.299.325-.477.796-.694 1.5l-.05.165c-.182.6-.425 1.401-.913 2.027-.615.79-1.532 1.228-2.824 1.208-1.04-.016-1.885-.367-2.547-.942-.64-.555-1.065-1.28-1.37-1.981-.306-.703-.521-1.453-.7-2.097l-.041-.146c-.17-.61-.302-1.085-.456-1.445-.358-.835-.794-1.279-1.172-1.487a1.37 1.37 0 0 0-1.14-.096c-.817.278-1.812 1.35-2.095 3.332-.124.873-.47 1.589-1.022 2.138-.54.536-1.216.851-1.904 1.043-1.255.35-2.799.348-4.18.347H11v-2h.113c1.508 0 2.8 0 3.782-.273.48-.134.81-.316 1.031-.536.21-.208.382-.508.452-1.001.35-2.452 1.67-4.346 3.432-4.944a3.36 3.36 0 0 1 2.749.238c.865.477 1.56 1.32 2.044 2.451.21.491.38 1.1.536 1.666l.05.177c.18.649.363 1.275.606 1.835.244.56.52.985.848 1.269.305.265.695.444 1.267.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M38.012 28a3 3 0 0 0-2.816 2h-6.368a2.981 2.981 0 0 0-5.632 0h-6.368a3 3 0 1 0 0 2h6.368a2.982 2.982 0 0 0 5.632 0h6.368a2.995 2.995 0 1 0 2.816-4m-24 4a1 1 0 1 1 0-1.998 1 1 0 0 1 0 1.999m12 0a1 1 0 1 1 0-1.998 1 1 0 0 1 0 1.999m12 0a1 1 0 1 1 0-1.998 1 1 0 0 1 0 1.999",
    clipRule: "evenodd"
  })));
};

export { IconDuoContract, IconDuoContract as default };
